import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed grid grid-rows-5 grid-cols-5 grid-flow-col items-stretch h-screen w-screen z-40 justify-items-center bg-black bg-opacity-50",
  id: "photoView"
}
const _hoisted_2 = { class: "col-start-2 row-span-1 col-span-3 flex justify-center items-center mt-16 text-white" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "col-start-5 row-span-1 col-span-1 flex justify-center items-center" }
const _hoisted_6 = { class: "row-start-2 col-start-2 col-span-3 row-span-3 justify-center items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "row-start-5 col-start-2 col-span-2 row-span-1 shrink-0 py-2 flex justify-center items-center text-white" }
const _hoisted_9 = { class: "flex flex-column items-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex flex-column items-center" }
const _hoisted_12 = {
  key: 0,
  class: "row-start-4 col-start-5 col-span-1 row-span-2 shrink-0 py-2 flex flex-col justify-center items-center text-white"
}
const _hoisted_13 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_14 = {
  key: 1,
  class: "flex flex-row items-center"
}
const _hoisted_15 = { class: "flex flex-row items-center" }
const _hoisted_16 = {
  key: 1,
  class: "row-start-5 col-start-4 col-span-1 row-span-1 shrink-0 py-2 flex justify-center items-center"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "text-5xl material-icons text-white hover:animate-pulse mr-2" }, "generating_tokens", -1)
const _hoisted_18 = { class: "text-white text-large" }
const _hoisted_19 = {
  key: 1,
  class: "fixed grid grid-rows-5 grid-cols-5 grid-flow-col items-stretch h-screen w-screen z-50 justify-items-center bg-black bg-opacity-50",
  id: "delPhotoConfirm"
}
const _hoisted_20 = { class: "bg-white row-start-3 col-start-2 col-span-3 row-span-1 mx-auto w-auto h-auto shadow-md rounded px-8 pt-8 pb-4 mb-2" }
const _hoisted_21 = { class: "grid-cols-1" }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { class: "block text-gray-700 text-sm font-bold mb-2" }
const _hoisted_24 = {
  key: 0,
  id: "DelPhotoComplete"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  class: "flex justify-between mt-8"
}
const _hoisted_27 = {
  key: 1,
  class: "flex justify-between mt-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_EventSelector = _resolveComponent("EventSelector")!
  const _component_LabelText = _resolveComponent("LabelText")!
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.clickedPhoto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isEditInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_InputText, {
                    label: "label.name",
                    testId: "PhotoTitleEdit",
                    text: _ctx.photoTitle,
                    "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.photoTitle) = $event))
                  }, null, 8, ["text"]),
                  _createVNode(_component_EventSelector, {
                    eventId: _ctx.photoEventId,
                    "onUpdate:eventId": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.photoEventId) = $event))
                  }, null, 8, ["eventId"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_LabelText, {
                    testId: "PhotoTitleView",
                    label: "label.name",
                    text: _ctx.clickedPhoto.title
                  }, null, 8, ["text"]),
                  _createVNode(_component_LabelText, {
                    testId: "PhotoEventView",
                    label: "label.event",
                    text: _ctx.eventName(_ctx.photoEventId)
                  }, null, 8, ["text"])
                ]))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_IconButton, {
              testId: "ClosePhotoView",
              icon: "scancel",
              onClicked: _ctx.close,
              label: ""
            }, null, 8, ["onClicked"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              ref: "imageRef",
              class: "max-h-full rounded-md",
              src: _ctx.clickedPhoto.photoURL,
              alt: "selected photo"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                ref: "imageRef",
                class: "h-32 lg:h-32 rounded-full p-2",
                src: _ctx.clickedPhoto.iconURL,
                alt: "nft icon"
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_IconButton, {
                icon: "share",
                onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openTweetPopup(_ctx.clickedPhoto.photoId))),
                label: "function.sharePhoto"
              })
            ])
          ]),
          (_ctx.isOwner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.isEditInfo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_ctx.processing == 'saving')
                        ? (_openBlock(), _createBlock(_component_IconButton, {
                            key: 0,
                            testId: "PhotoInfoSaving",
                            icon: "sync",
                            animate: "animate-spin",
                            label: "function.save"
                          }))
                        : (_ctx.processing == 'saveComplete')
                          ? (_openBlock(), _createBlock(_component_IconButton, {
                              key: 1,
                              testId: "PhotoInfoSaveComplete",
                              icon: "save",
                              label: "function.saveComplete"
                            }))
                          : (_openBlock(), _createBlock(_component_IconButton, {
                              key: 2,
                              onClicked: _ctx.savePhotoInfo,
                              testId: "PhotoInfoSave",
                              icon: "save",
                              label: "function.save"
                            }, null, 8, ["onClicked"]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_IconButton, {
                        testId: "EditInfo",
                        icon: "edit",
                        label: "function.editPhotoInfo",
                        onClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEditInfo = true))
                      })
                    ])),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_IconButton, {
                    testId: "DelPhoto",
                    icon: "delete",
                    label: "function.deletePhoto",
                    onClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDelete = true))
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isWalletUser && _ctx.featureConfig.enableNFTReq)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "flex flex-column items-center",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nftRequest && _ctx.nftRequest(...args)))
                }, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("message.nftRequestButton")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDelete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, [
                  (_ctx.processing == 'deleteComplete')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("message.deletePhotoComplete")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("message.deletePhotoConfirm")), 1))
                ])
              ]),
              (_ctx.processing == 'deleteComplete')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close())),
                      id: "DelPhotoClose",
                      class: "inline-block bg-gray-200 hover:bg-gray-400 rounded-full text-sm font-semibold text-gray-700 mx-4 p-3 py-1",
                      type: "button"
                    }, _toDisplayString(_ctx.$t("function.close")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deletePhoto())),
                      id: "DelPhotoDo",
                      class: "inline-block bg-gray-200 hover:bg-gray-400 rounded-full text-sm font-semibold text-gray-700 mx-4 p-3 py-1",
                      type: "button"
                    }, _toDisplayString(_ctx.$t("function.delete")), 1),
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isDelete = false)),
                      id: "DelPhotoCancel",
                      class: "inline-block bg-gray-200 hover:bg-gray-400 rounded-full text-sm font-semibold text-gray-700 mx-4 px-3 py-1",
                      type: "button"
                    }, _toDisplayString(_ctx.$t("function.cancel")), 1)
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}